import React from 'react'

import Author from '../../components/Author'
import { fetchAuthorData } from '../../data/server/query-transform/fetchAuthorData'

import Head from 'next/head'

const AuthorPage = ({ stories, author, params, metadata }) => (
  <>
    <Head>
      <title>News 12 - {metadata.title}</title>
    </Head>
    <Author storiesData={stories} author={author} params={params} metadata={metadata} />
  </>
)

export async function getServerSideProps(context) {
  return await fetchAuthorData({ context })
}

export default AuthorPage
